import { ComponentMessage } from '../../../../enums/ComponentMessage';

export const noGridData = ComponentMessage.NoData;
